import { NavigationWorkspace } from "../models"
import { ICollection } from "../components/resources"
import { IPrintOptions } from "../components/printView"

export function collectionUrl(collection: ICollection): string {
    const { workspace, id } = collection
    if (!workspace || !workspace.doesExist || !collection.doesExist) {
        return ""
    }
    return workspace.id === 0
        ? `dashboard/${id}f`
        : `workspace/${workspace?.id}/${id}f`
}

export function workspaceUrl(
    applicationPath: string,
    workspace: NavigationWorkspace,
): string {
    const { Id, ShowCoverPage } = workspace
    return Id === 0
        ? `${applicationPath}/dashboard`
        : ShowCoverPage
        ? `${applicationPath}/workspace/${Id}/cover`
        : `${applicationPath}/workspace/${Id}`
}

export function workspaceCoverPageUrl(
    applicationPath: string,
    workspaceId: number,
): string {
    return `${applicationPath}/workspace/${workspaceId}/cover`
}

export function workspaceConceptUrl(
    applicationPath: string,
    workspaceId: number,
    conceptId: number,
): string {
    return `${applicationPath}/workspace/${workspaceId}/${conceptId}l`
}

export function workspaceItemUrl(
    applicationPath: string,
    workspaceId: number,
    conceptId: number,
    itemId: number,
): string {
    return `${applicationPath}/workspace/${workspaceId}/${conceptId}l/${itemId}`
}

export function workspaceSettingsUrl(
    applicationPath: string,
    workspaceId: number,
): string {
    return `${applicationPath}/workspace/${workspaceId}/settings`
}

export function conceptUrl(applicationPath: string, conceptId: number): string {
    return `${applicationPath}/config/concepts/${conceptId}`
}

export function createConceptInWorkspaceUrl(
    applicationPath: string,
    workspaceId: number,
): string {
    return `${applicationPath}/workspace/${workspaceId}/createnewlist`
}

export function prefixUrl(url: string): string {
    // if the url starts with www. we prefix with http
    // this way both http and https websites will work
    // as that website should redirect from http to https if it's available
    const prefix = url.startsWith("www.") ? "http://" : ""
    return `${prefix}${url}`
}

export function getItemDetailPrintUrl(
    applicationPath: string,
    itemId: number,
    printOptions: IPrintOptions,
): string {
    const { shouldPrintAttachments, shouldPrintComments, shouldPrintHistory } =
        printOptions
    return `${applicationPath}/PrintableViews/ItemDetailPrintView.aspx?itemId=${itemId}&attachments=${shouldPrintAttachments}&comments=${shouldPrintComments}&history=${shouldPrintHistory}`
}

export function itemDetailUrl(
    applicationPath: string,
    relativePath?: string,
    itemId?: number,
): string {
    return !!relativePath
        ? `${applicationPath}${relativePath}`
        : `${applicationPath}/item/${itemId}`
}
